import React from 'react'

import { getPipeTypesHandbook } from 'services/apiRequests'

import { useDispatch } from 'react-redux'
import { setDirectoryItems, setId, setVersionId } from 'store/directorySlice'

const useGetPipeTypes = (requestData: boolean | undefined) => {
  const dispatch = useDispatch()

  const tryToGetPipeTypes = async () => {
    await getPipeTypesHandbook().then((res) => {
      dispatch(setId(res.data.id))
      dispatch(setVersionId(res.data.id))
      dispatch(
        setDirectoryItems(
          res.data.units.map((unit) => {
            return {
              ...unit,
              modified: false,
            }
          }),
        ),
      )
    })
  }

  React.useEffect(() => {
    tryToGetPipeTypes().then()
  }, [requestData])

  return
}

export default useGetPipeTypes
